export enum ADMIN_ROLES {
  CLIENTS_MANAGER = 'CLIENTS_MANAGER',
  ADMIN = 'ADMIN'
}